export default __webpack_public_path__ + "static/media/gb-eng.c15527cb.svg";